import { triggerFastestPositionRefresh } from '@ui/hooks/trade/usePositions/usePositionRefreshAcceleration';
import { queryClient } from '@ui/lib/reactQuery';
import { GET_LIMIT_ORDERS_BATCH } from '@ui/services/contract/hooks/LimitOrderFacet/useGetLimitOrdersBatch/query';
import { GET_DECREASE_ORDERS } from '@ui/services/contract/hooks/TradingPortalFacet/useDecreaseOrders/query';
import { GET_POSITIONS_V3_BATCH } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV3Batch/query';
import { useCallback } from 'react';

export const useInvalidatePositionQuery = () => {
  return useCallback(() => {
    triggerFastestPositionRefresh();
    queryClient.invalidateQueries({
      queryKey: [GET_POSITIONS_V3_BATCH],
    });
    queryClient.invalidateQueries({
      queryKey: [GET_DECREASE_ORDERS],
    });
  }, []);
};

export const useInvalidateLimitOrderQuery = () => {
  return useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [GET_LIMIT_ORDERS_BATCH],
    });
  }, []);
};
